import React from 'react'
import style from './style'
import propTypes from './prop'
import { withStyles } from '@material-ui/core'
import { CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'

/**
 *
 * @param {*} props
 */
const TablePaginationActions = props => {
  const { classes, onPageChange, page, rowsPerPage, count } = props
  /**
   *
   */
  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0)
  }

  /**
   *
   */
  const handleBackButtonClick = event => {
    onPageChange(event, page - 1)
  }

  /**
   *
   */
  const handleNextButtonClick = event => {
    onPageChange(event, page + 1)
  }

  /**
   *
   */
  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  return (
    <div className={classes.root}>
      <CoreIconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        color="secondary"
        variant="text"
        size="small"
      >
        <Icon icon="ic:round-first-page" />{' '}
      </CoreIconButton>
      <CoreIconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        color="secondary"
        variant="text"
        size="small"
      >
        <Icon icon="icon-park-outline:left" />{' '}
      </CoreIconButton>
      <CoreIconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        color="secondary"
        variant="text"
        size="small"
      >
        <Icon icon="icon-park-outline:right" />
      </CoreIconButton>
      <CoreIconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        color="secondary"
        variant="text"
        size="small"
      >
        <Icon icon="ic:round-last-page" />
      </CoreIconButton>
    </div>
  )
}
TablePaginationActions.propTypes = propTypes

export default withStyles(style)(TablePaginationActions)
